import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { AI_AUTOMATIONS_LOCAL_API_REQUESTS } from './constants';

/**
 * GET /nerobotti/automations?businessId= — the company's scheduled AI tasks.
 *
 * The API answers only for a company the caller may manage, which is decided
 * on that company's employer root, so a 403 here is a real answer and not a
 * bug to route around.
 */
export const getAutomations = async ({ businessId }) => {
  const signedRequest = await createSignedGetRequest({
    apiPath: `nerobotti/automations?businessId=${encodeURIComponent(
      businessId
    )}`,
    isLocalApiRequest: AI_AUTOMATIONS_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
